import { DEVICE } from '@/shared/config';
import { useMergeState } from '@/shared/lib/customHooks';
import { useRef } from 'react';
import { t } from 'ttag';
import type { DeviceManualsPdfState } from './deviceManualsPdf.types';

/**
 * Supplies the support-page device manual viewer with its Bioflux and Biocore category toggle. Holds the two labelled options in a ref, defaults state.category to the first of them and exposes a change handler that stores a new pick.
 *
 * @returns The category option ref, the current state and the category change handler.
 */
export const useDeviceManualsPdf = () => {
  const categoryList = useRef([
    {
      label: t`Bioflux`,
      value: DEVICE.BIOFLUX,
    },
    {
      label: t`Biocore`,
      value: DEVICE.BIOTRES,
    },
  ]);

  const [state, setState] = useMergeState<DeviceManualsPdfState>({
    category: categoryList.current[0].value,
  });

  /**
   * Stores a device-category choice made through the manuals toggle buttons. Merges the value into state under the supplied field name.
   *
   * @param name - State field to update, matching the toggle button name.
   * @param value - Selected device category value.
   * @returns Nothing.
   */
  const onChange = (name: any, value: any) => {
    setState({ [name]: value });
  };

  return {
    categoryList,
    state,
    onChange,
  };
};
